import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 6px;
  height: 550px;
  width: 490px;
  line-height: 18px;
  margin: 55px 0;
  text-align: center;

  h1 {
    font-size: 18px;
    font-weight: 600;
    margin-top: 40px;
  }

  h2 {
    font-size: 14px;
    font-weight: 400;
    margin-top: 15px;
    max-width: 300px;
  }

  > span {
    color: ${(props) => props.theme.colors.grayAlternative};
    font-size: 12px;
    margin-top: 15px;
  }
`;

/**
 * ⛔ O `StoreLink` saiu na 0.35 junto com o botão da Play Store: a URL apontava para o
 * `com.cincoapp`, que é o app **descontinuado**. Não foi substituído por outro destino
 * porque o paciente não tem painel web e o `cinco-b2c` não está publicado — o canal dele é o
 * WhatsApp.
 */
